import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from '../modules/components/Section';
import Eyebrow from '../modules/components/Eyebrow';
import Button from '../modules/components/Button';

function ProductWithMakers() {
  return (
    <Section bg="paper" py={{ xs: 12, sm: 17.5 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: { xs: 6, sm: 11 },
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            aspectRatio: { xs: '4 / 3', sm: '4 / 5' },
            backgroundImage: 'url(/images/Philosophy.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
        <Box>
          <Eyebrow>Concept</Eyebrow>
          <Typography variant="h2" component="h2">
            建築士と一緒につくる家
          </Typography>
          <Typography sx={{ fontSize: 15.5, color: 'text.secondary', mt: 3.5, mb: 4.5 }}>
            プランや庭、インテリア。とにかく考えることが多い家づくり。相談する相手がばらばらでは、トータルデザインは難しいもの。当社では建築士・エクステリアプランナー・インテリアコーディネーターの資格を持ったスタッフが、一貫した家づくりをご提案します。
          </Typography>
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              fontFamily: "'Noto Serif JP', serif",
              fontSize: 17,
              letterSpacing: '.14em',
              borderBottom: (theme) => `1px solid ${theme.palette.green}`,
              pb: 0.75,
              mb: 4.5,
              color: 'sumi',
            }}
          >
            見積・相談　無料
          </Box>
          <br />
          <Button href="/flow">家づくりの流れを見る</Button>
        </Box>
      </Box>
    </Section>
  );
}

export default ProductWithMakers;
